import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../screens/Login"; // Importa el componente de inicio de sesión
import FormWorkspace from "../screens/FormWorkspace"; // Importa el componente de creación de espacio de trabajo
import Register from "../screens/Register";
import HomePage from "../screens/HomePage";
import Invitation from "../screens/Invitation";
import PrivacyPolicy from "../screens/PrivacyPolicy";
import DeleteAccount from "../screens/DeleteAccount";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Login />} />{" "}
        <Route path="/form-workspace" element={<FormWorkspace />} />{" "}
        <Route path="/register" element={<Register />} />
        <Route path="home-page" element={<HomePage />} />
        <Route path="/accept-invitation" element={<Invitation />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account-info" element={<DeleteAccount />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
